<template>
  <el-dialog
      :title="title"
      :visible.sync="open"
      width="900px"
      center
      append-to-body
      @close="cancel"
      :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="对接平台：" prop="platform_id">
            <div v-if="title === '详情'">{{form.platform_text}}</div>
            <el-select v-else v-model="form.platform_id" placeholder="选择平台" style="width: 100%">
              <el-option
                  v-for="item in platformList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="ID：" prop="third_id">
            <div v-if="title === '详情'">{{form.third_id}}</div>
            <el-input v-else v-model="form.third_id" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="骰主：" prop="dice_master">
            <div v-if="title === '详情'">{{form.dice_master}}</div>
            <el-input v-else v-model="form.dice_master" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="是否有黑名单：" prop="is_blacklist">
            <div v-if="title === '详情'">{{form.is_blacklist_text}}</div>
            <el-select v-else v-model="form.is_blacklist" placeholder="请选择" style="width: 100%">
              <el-option
                  v-for="item in blackList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邀请条件：" prop="invite">
            <div v-if="title === '详情'">{{form.invite}}</div>
            <el-input v-else v-model="form.invite" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="昵称：" prop="third_name">
            <div v-if="title === '详情'">{{form.third_name}}</div>
            <el-input v-else v-model="form.third_name" placeholder="请输入骰子昵称"/>
          </el-form-item>
          <el-form-item label="框架：" prop="dice_id">
            <div v-if="title === '详情'">{{form.dice_text}}</div>
            <el-select v-else v-model="form.dice_id" placeholder="选择框架" style="width: 100%">
              <el-option
                  v-for="item in diceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模式：" prop="mode">
            <div v-if="title === '详情'">{{form.mode_text}}</div>
            <el-select v-else v-model="form.mode" placeholder="选择模式" style="width: 100%">
              <el-option
                  v-for="item in modeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <div v-if="title === '详情'">{{form.status_text}}</div>
            <el-select v-else v-model="form.status" placeholder="选择状态" style="width: 100%">
              <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：" prop="memo">
            <div v-if="title === '详情'">{{form.memo || '无'}}</div>
            <el-input v-else v-model="form.memo" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="介绍：" prop="intro">
        <div v-if="title === '详情'">{{form.intro}}</div>
        <el-input v-else v-model="form.intro" :rows="4" type="textarea" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <div class="flex al-cn ju-cn pt20" v-if="title !== '详情'">
      <el-checkbox v-model="checked">
        <div class="cl333 f12">我已阅读并同意</div>
      </el-checkbox>
      <div class="f12 cl0066FF pointer" @click="agreement">《用户内容发布规范与法律责任协议》</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="title !== '详情'" type="primary" @click="submitForm">提 交</el-button>
      <el-button @click="cancel">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {botAdd, botEdit} from "@/api/api";

export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          platform_id: '', // 对接平台
          dice_id: '', // 全部框架
          third_id: '', // ID
          dice_master: '', // 骰主
          third_name: '', // 昵称
          intro: '', // 介绍
          is_blacklist: '', // 是否黑名单
          invite: '', // 邀请条件
          mode: '', // 模式
          status: '', // 状态
          memo: '', // 备注
        }
      }
    },
    title: {
      type: String,
      default: ''
    },
    // 模式
    modeList: {
      type: Array,
      default: () => []
    },
    // 状态
    statusList: {
      type: Array,
      default: () => []
    },
    // 黑名单
    blackList: {
      type: Array,
      default: () => []
    },
    // 对接平台
    platformList: {
      type: Array,
      default: () => []
    },
    // 游戏
    diceList: {
      type: Array,
      default: () => []
    }
  },
  name: "dialog",
  data() {
    return {
      open: true,
      dockingPlatform: [], //对接平台
      rules: {
        platform_id: [
          {required: true, message: '请选择对接平台', trigger: 'blur'}
        ],
        dice_id: [
          {required: true, message: '请选择游戏', trigger: 'blur'}
        ],
        third_id: [
          {required: true, message: '请输入ID', trigger: 'blur'}
        ],
        dice_master: [
          {required: true, message: '请输入骰主', trigger: 'blur'}
        ],
        third_name: [
          {required: true, message: '请输入昵称', trigger: 'blur'}
        ],
        intro: [
          {required: true, message: '请输入介绍', trigger: 'blur'}
        ],
        is_blacklist: [
          {required: true, message: '请选择是否黑名单', trigger: 'blur'}
        ],
        invite: [
          {required: true, message: '请输入邀请条件', trigger: 'blur'}
        ],
        mode: [
          {required: true, message: '请选择模式', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'blur'}
        ],
      },
      checked: false,
    }
  },
  watch: {},
  mounted() {

  },
  methods: {
    agreement() {
      this.$emit("agreement")
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (!this.checked) {
            this.$message({message: "请先阅读并同意《用户内容发布规范与法律责任协议》", type: "error"});
            return
          }
          if (this.form.id) {
            botEdit(this.form).then(response => {
              if (response.code === 1) {
                this.$message({message: "修改", type: "success"});
                this.resetForm('form')
                this.cancel(); // 关闭对话框
                this.$emit("refresh")//刷新父页面
              }
            });
          } else {
            botAdd(this.form).then(response => {
              if (response.code === 1) {
                this.$message({message: "新增成功", type: "success"});
                this.resetForm('form')
                this.cancel(); // 关闭对话框
                this.$emit("refresh")//刷新父页面
              }
            });
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    },
    // 取消按钮
    cancel() {
      this.$emit("cancel");
    }
  }
}
</script>


<style scoped lang="scss">

</style>
